export default [
    {
		path: "/attendance",
		component: () => import("../views/Attendance/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/attendance/register/:eventid",
		component: () => import("../views/Attendance/Register.vue"),
	},
	{
		path: "/attendance/absences",
		component: () => import("../views/Attendance/Absences.vue"),
	},
	{
		path: "/attendance/checkin/:token?",
		component: () => import("../views/Attendance/Checkin.vue"),
		meta: {
			hasmainmenu: true
		}
	},
]
